module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKpJREFUeNpiYKAzEADi+UD8H4gdKDFoP9SQ95QY4gA1BIQbcClixuENCyA2AGIOKBuEZwDxSSgbBF7gsz0A6vz/SPg+kteQ8XqopRjAAItiQjgAm0HrSTQkAZe33pNgyH10zUxogUwseIDPIFKAAr7od8CmAE9K/wjEJ7BJ9pMRa/NxOZdUg9bjcvJ8Eg1SwOf3+0QaUkAoIA2QDHsPDbsGtGzST7MCCyDAALUKdCZA6knsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/appdownicon/iosapp.png
// module id = 53Ja
// module chunks = 129